import React from 'react'
import TalentAppStep from "../components/TalentAppStep";
import BrandForm from "../components/BrandForm";

export default class BrandsStep extends TalentAppStep
{
    static path = '/brands';
    static LastUpdatedMethod = 'lastUpdatedBrands';
    static HasRequirements = true;

    /**
     * The title shown on the form
     */
    static StepTitle = 'Brands';
    static StepShortTitle = 'Brands';
    /**
     * The subtitle shown on the form
     */
    static StepSubtitle = "Add companies below that you have worked with that reflect your overall experience and expertise. If you have worked for an agency or consultancy, be sure to include the end clients that your work supported.";
    /**
     * The start page info tile
     */
    static StepInfo = 'Add affiliated brands to showcase who you have worked with in the past';
    /**
     * The Step Section to be grouped in after application approval
     */
    static StepSection = 'Work Highlights';
    /**
     * Show brief details for user
     */
     static ProfileSectionSummary = (user) => {
        if(!this.hasCompleted(user)) return false;
        return `${user.brands?.length} Brands`;
    };
    /**
     * The step needed before editing
     */
    static StepNeedsValidation(user) {
        if (!user.isOnTalentMarketplace()) {
            return false;
        }
        if (!user.validateBrands() || !TB.filter(user.brands || [], i => TB.isDefined(i?.id)).length) {
            return this;
        }

        return false;
    };

    static hasCompleted(user) {
        return !user.isOnTalentMarketplace() || TB.filter(user.brands || [], i => (TB.isDefined(i?.id) || i?.name)).length > 0
    }

    /**
     * Check if we should prevent application from saving and show alert
     */
    static async getValidProps(user) {
        return user.validateBrands()
    };

    /**
     * @param {User} user
     * @returns {Object}
     */
    static reviewMapping(user) {
        let review = {};

        TB.map(user.brands || [],(brand, index) => {
            review[`Brand #${index + 1}`] = brand.name;
        })

        return review;
    }

    /**
     * Render the form
     *
     * @returns {Form}
     */
    renderFormFooter() {
        return (
            <div className="pb-6">

                {this.renderChildForm({
                    displayName: 'Brand',
                    ChildFormComponent: BrandForm,
                    formProps:{
                        brands: {...this.props.user}?.brands || [],
                    },
                    userProp: 'brands'
                })}
            </div>
        );
    }
    /**
     * Are requirements optional
     *
     * @returns boolean
     */
    isRequirementOptional() {
        return !this.props.authUser.isOnTalentMarketplace?.();
    }
    /**
     * Are requirements completed?
     *
     * @returns boolean
     */
    isRequirementComplete() {
        return !this.props.authUser.isOnTalentMarketplace() || TB.filter(this.props.authUser.brands || [], brand => !!brand?.id)?.length >= 1;
    }
    /**
     * Requirement messaging
     *
     * @returns string
     */
    requirementInfo() {
        return this.props.authUser.isOnTalentMarketplace() ? 'At least 1 brand is required.' : 'Brands are optional and not required.';
    }

}